import React from "react";
import IssuesetItem from "./issueset_item";
import {getTemplateIssueset} from "../utils/issueset";
import {IssuesetId, PlaybookIssueset} from "common/types/issueset";

export interface ContractType {
  id: number;
  name: string;
  issuesets: PlaybookIssueset[];
  projects: number[];
}

interface ContractTypesListProps {
  contractTypes: ContractType[];
  selectedIssueset?: PlaybookIssueset;
  getIssuesets: (contractType: ContractType | undefined) => PlaybookIssueset[];
  onSelectIssueset: (
    contractType: ContractType,
    issueset: PlaybookIssueset,
  ) => () => void;
  onStarIssueset: (
    contractTypeId: number,
    issuesetId: IssuesetId,
    isStar: boolean,
  ) => () => void;
  isAdmin: boolean;
}

const ContractTypesList: React.FC<ContractTypesListProps> = ({
  contractTypes,
  selectedIssueset,
  getIssuesets,
  onSelectIssueset,
  onStarIssueset,
  isAdmin,
}) => {
  const renderIssuesetList = (contractType: ContractType) => {
    const issuesets = getIssuesets(contractType);
    if (!selectedIssueset) {
      return null;
    }

    return (
      <div style={{margin: "0 1rem"}} key="issueset-list">
        {issuesets.map(issueset => (
          <IssuesetItem
            key={issueset.id}
            issueset={issueset}
            templateIssueset={getTemplateIssueset(issueset, issuesets)}
            isSelected={issueset.id === selectedIssueset.id}
            onSelectIssueset={onSelectIssueset(contractType, issueset)}
            onStarIssueset={onStarIssueset(
              contractType.id,
              issueset.id,
              issueset.is_star,
            )}
            isAdmin={isAdmin}
          />
        ))}
      </div>
    );
  };

  return (
    <div style={{width: "40em", paddingTop: "1rem", overflowY: "scroll"}}>
      {contractTypes.map(contractType => (
        <div key={contractType.id}>
          <div
            style={{
              fontWeight: "bold",
              padding: "1rem",
              margin: "0 1rem",
              border: "1px solid #444",
              backgroundColor: "#ccc",
            }}
          >
            {contractType.name}
          </div>
          <div>{renderIssuesetList(contractType)}</div>
        </div>
      ))}
    </div>
  );
};

export default ContractTypesList;
